<template>
  <div class="v-img">
    <img
      :src="src"
      :alt="alt"
      :key="src"
      :style="imgStyles"
    >
    <div v-if="!isLoaded" class="v-img__spinner"><div></div><div></div><div></div><div></div></div>
  </div>
</template>

<script>
export default {
  props: {
    alt: {
      default: '',
      type: String
    },
    src: String,
    fit: {
      default: 'cover',
      type: String
    }
  },

  data () {
    return {
      isLoaded: false
    }
  },

  computed: {
    imgStyles () {
      return [
        { 'object-fit': this.fit },
        { 'opacity': this.isLoaded ? '1' : '0' }
      ]
    }
  },

  created () {
    const img = new Image()
    img.src = this.src
    img.onload = () => {
      this.isLoaded = true
    }
  }
}
</script>

<style lang="scss">
.v-img {
  min-height: 40px;
  position: relative;

  img {
    height: 100%;
    transition: opacity 0.6s;
    width: 100%;
  }

  &__spinner {
    display: inline-block;
    position: absolute;
    top: calc(50% - 20px);
    left: calc(50% - 20px);
    width: 40px;
    height: 40px;

    div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 32px;
      height: 32px;
      margin: 4px;
      border: 4px solid #eee;
      border-radius: 50%;
      animation: rotate 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: #eee transparent transparent transparent;

      &:nth-child(1) {
        animation-delay: -0.45s;
      }
      &:nth-child(2) {
        animation-delay: -0.3s;
      }
      &:nth-child(3) {
        animation-delay: -0.15s;
      }
    }
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
